"use strict";
/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mobx_state_tree_1 = require("mobx-state-tree");

var ConditionalFormatModel_1 = __importDefault(require("./ConditionalFormatModel"));

var ColorPickerModel_1 = __importDefault(require("./ColorPickerModel"));
/**
 * There are several ways to create this model and populate the conditionalFormats array list:
 *
 * 1. ConditionalFormatsModelFactory.create({ conditionalFormats }, { getVisType, conditionalFormattingApi })
 *
 * 2. ConditionalFormatsModelFactory.create({}, { getVisType, conditionalFormattingApi, condFormatJsonSpecList }) where condFormatJsonSpecList is the json array of condition formats to create
 *
 * 3. via the reInitialize action API
 */


var PARENT_LEVEL = 1;
var ConditionalFormatsModelFactory = mobx_state_tree_1.types.model('ConditionalFormatsModel', {
  summaryFillColor: mobx_state_tree_1.types.maybeNull(mobx_state_tree_1.types.string),
  conditionalFormats: mobx_state_tree_1.types.optional(mobx_state_tree_1.types.array(ConditionalFormatModel_1.default), []),
  colorPickerModel: mobx_state_tree_1.types.maybe(ColorPickerModel_1.default)
}).volatile(function () {
  return {
    getVisTypeFn: null,
    conditionalFormattingApi: null,
    uiContext: null
  };
}).actions(function (self) {
  return {
    afterCreate: function afterCreate() {
      var env = mobx_state_tree_1.getEnv(self);
      var getVisType = env.getVisType,
          conditionalFormattingApi = env.conditionalFormattingApi,
          uiContext = env.uiContext;
      self.getVisTypeFn = getVisType;
      self.conditionalFormattingApi = conditionalFormattingApi;
      self.uiContext = uiContext;
      var ancestorLevel = PARENT_LEVEL;
      self.colorPickerModel = ColorPickerModel_1.default.create({
        ancestorLevel: ancestorLevel
      });
    },
    addConditionalFormat: function addConditionalFormat(spec) {
      self.conditionalFormats.push(__assign({}, spec));
      return self.conditionalFormats[self.conditionalFormats.length - 1];
    },
    setSummaryFillColor: function setSummaryFillColor(hexColor) {
      var upperHexColor = hexColor && hexColor.toUpperCase();

      if (self.summaryFillColor !== upperHexColor) {
        self.conditionalFormattingApi.setSummaryFillColor(upperHexColor);
      }
    },
    setSummaryFillColorValueFromContentModel: function setSummaryFillColorValueFromContentModel(hexColor) {
      self.summaryFillColor = hexColor;
    }
  };
}).views(function (self) {
  return {
    getConditionalFormatById: function getConditionalFormatById(dataItemId) {
      return self.conditionalFormats.find(function (conditionalFormat) {
        return conditionalFormat.getDataItemId() === dataItemId;
      });
    },

    get hasConditionalFormats() {
      return self.conditionalFormats.length > 0;
    },

    getVisType: function getVisType() {
      return self.getVisTypeFn();
    },
    getConditionalFormattingApi: function getConditionalFormattingApi() {
      return self.conditionalFormattingApi;
    },
    loadPalette: function loadPalette(paletteId) {
      return self.uiContext.getPalette(paletteId);
    },
    loadPalettes: function loadPalettes() {
      return self.uiContext.getPalettes();
    },
    loadColorPalette: function loadColorPalette(paletteId) {
      return self.uiContext.getColorPalette(paletteId);
    },
    loadColors: function loadColors(paletteId) {
      return Promise.all([self.uiContext.getPalette(paletteId), self.uiContext.getFavoriteColors()]).then(function (_a) {
        var paletteColors = _a[0],
            favoriteColors = _a[1];
        paletteColors = paletteColors && paletteColors.fills || [];
        return [paletteColors, favoriteColors];
      });
    },
    getDashboardColorSet: function getDashboardColorSet() {
      return self.uiContext.getColors().getDashboardColorSet();
    },
    getSummaryFillColor: function getSummaryFillColor() {
      return self.summaryFillColor;
    },
    getColorPickerModel: function getColorPickerModel() {
      return self.colorPickerModel;
    },
    getUIContext: function getUIContext() {
      return self.uiContext;
    }
  };
});
exports.default = ConditionalFormatsModelFactory;
